import { render, staticRenderFns } from "./pagi.vue?vue&type=template&id=2c7c8f6f&scoped=true&"
import script from "./pagi.vue?vue&type=script&lang=js&"
export * from "./pagi.vue?vue&type=script&lang=js&"
import style0 from "./pagi.vue?vue&type=style&index=0&id=2c7c8f6f&lang=less&scoped=true&"
import style1 from "./pagi.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7c8f6f",
  null
  
)

export default component.exports